module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-event.9a50e0d6.webp";